<template>
  <div :class="templateClass">
    <div class="row top">
      <!-- <img class="espa" src="@/assets/espa-banner.png" v-if="!isAuthenticated" /> -->
      <div class="row">
        <div :class="btnContainerClass">
          <generic-button :returnUrl="btnUrl" :title="buttonTitle" :icon="btnIcon" :front="btnFront"></generic-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-md-offset-2 content">
          <h1><u>Πολιτική Προστασίας Προσωπικών Δεδομένων</u></h1>
          <div id="topic" v-html="text"></div>
        </div>
      </div>
    </div>
    <app-footer v-if="!isAuthenticated" />
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import Footer from "../footer/footer.vue";
import GenericButton from "../../components/shared/genericButton";
import notify from "devextreme/ui/notify";
export default {
  inject:['mySpinner'],
  components: {
    "app-footer": Footer,
    GenericButton,
  },
  data() {
    return {
      text: "",
      buttonTitle: "Είσοδος",
      btnIcon: "enter-outline",
      btnUrl: "/login",
      btnFront: true,
      templateClass: "container",
      btnContainerClass: "col-md-2 out",
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    async getPrivacyPolicy() {
      //debugger;
      this.mySpinner.val=true;
      const res = await mainService.get(`/globalParams/GetPrivacyPolicy`);
       if (res.status != 200) {
         notify("Παρουσιάστηκε πρόβλημα κατά την ανάσυρση των δεδομένων", "error", 1000);
       }
      this.text = res.data;
      this.mySpinner.val=false;
    },
  },
  async mounted() {
    this.getPrivacyPolicy();
    if (this.isAuthenticated) {
      this.buttonTitle = "Επιστροφή";
      this.btnIcon = "arrow-back-circle-outline";
      this.btnUrl = "";
      this.btnFront = false;
      this.templateClass = "";
      this.btnContainerClass = "col-md-2";
    }
  },
};
</script>
<style lang="scss" scoped>

#topic{
  text-align: left;
 font-size: 12px;
 h1{
   font-size: 16px;
 }
 h2{
    font-size: 14px !important;
  }
}

.espa {
  max-width: 90vw;
  margin: 1em 0;
}

.container .page-title,
.container .row.top {
  margin: 1rem 0;
  text-align: center;
}

.out::v-deep {
  float: right !important;
  .generic-button {
    left: 0px !important;
  }
}

</style>
